import { Mapper } from '../../../common/ddd/mapper.base';
import { ChallengeSentimentEntity } from '../../../core/domain/entities/challenge-insights/challenge-sentiment.entity';
import { GetAccountMetricsInsightChartDataResponse } from '../../../interface/dtos/challenge-insights/get-account-metrics-insight-digital-working-hours-chart-data.response.dto';

export class ChallengeSentimentChartDataMapper
  implements
    Omit<
      Mapper<
        ChallengeSentimentEntity,
        GetAccountMetricsInsightChartDataResponse
      >,
      'toDomain'
    >
{
  toResponse(
    entity: ChallengeSentimentEntity
  ): GetAccountMetricsInsightChartDataResponse {
    return ChallengeSentimentChartDataMapper.toResponse(entity);
  }
  static toResponse(
    entity: ChallengeSentimentEntity
  ): GetAccountMetricsInsightChartDataResponse {
    const average = entity.value === null ? null : Number(entity.avg);
    const totalValue = entity.value === null ? null : Number(entity.value);
    return {
      value: average,
      totalValue,
      formattedValue: average === null ? null : `${average.toFixed(1)}`,
      formattedTotalValue:
        totalValue === null ? null : `${totalValue.toFixed(1)}`,
      date: entity.date.toISOString().split('T')[0],
      uniqueUserCount: entity.userCount,
    };
  }
}
